import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_ADD_ON_SERVICE = 'GET_ADD_ON_SERVICE';
export const GET_ADD_ON_SERVICE_SUCCESS = 'GET_ADD_ON_SERVICE_SUCCESS';
export const GET_ADD_ON_SERVICE_FAILURE = 'GET_ADD_ON_SERVICE_FAILURE';

// Action Creators
export const fetchGetAddOnService = () => ({
  type: GET_ADD_ON_SERVICE,
});

export const fetchGetAddOnServiceSuccess = (data) => ({
  type: GET_ADD_ON_SERVICE_SUCCESS,
  payload: data,
});

export const fetchGetAddOnServiceFailure = (error) => ({
  type: GET_ADD_ON_SERVICE_FAILURE,
  payload: error,
});

// Thunk Function
export const getAddOnServiceCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetAddOnService(data, external));
    try {
      const response = await getMethodWithToken(
        url.getAddOnServiceDropDownList + data?.id + '/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetAddOnServiceSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetAddOnServiceFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetAddOnServiceFailure(error.message));
    }
  };
};
